module.exports = __webpack_public_path__ + "img/downloadicon.dc418d31.svg";